// extracted by mini-css-extract-plugin
module.exports = {"profileWrap":"Profilebeeff7b7c5dde9109d2d892b64eae66e","pageWrapper":"Profileec534a6f40e7431222c551a604026fa1","body":"Profile7691384628f73487226b798d99c7c751"};